import ProductDetailPanel from './productDetailPanel.container';

export default ProductDetailPanel;